import { Inject, Injectable } from '@angular/core';

import {
  CryptoStorage,
  LocalStorageService,
  SESSION_STORAGE,
  STORAGE_CONFIG,
  StorageConfig,
} from '@personal-area/storage';

import {
  ResubmitForm,
} from '../models/resubmit-form';
import { RESUBMIT_FORM_KEY } from '../constants/storage-keys';

@Injectable({ providedIn: 'root' })
export class CaptchaService {
  constructor(
    private _localStorageService: LocalStorageService,
    @Inject(STORAGE_CONFIG) private _storageConfig: StorageConfig,
    @Inject(SESSION_STORAGE) private _sessionStorage: Storage,
  ) {}

  public pushFormForResubmit(form: ResubmitForm): string {
    const secretKey = CryptoStorage.generateKey(16);

    this._localStorageService.setItem(
      RESUBMIT_FORM_KEY,
      form,
      1,
      new CryptoStorage(
        this._sessionStorage,
        this._storageConfig.version,
        secretKey,
      ),
    );

    return secretKey;
  }

  public popFormForResubmit(secretKey: string): ResubmitForm | null {
    const storage = new CryptoStorage(
      this._sessionStorage,
      this._storageConfig.version,
      secretKey,
    );
    const result = this._localStorageService.getItem<ResubmitForm>(
      RESUBMIT_FORM_KEY,
      storage,
    );

    if (result) {
      this._localStorageService.removeItem(RESUBMIT_FORM_KEY, storage);
    }

    return result;
  }
}
